module.exports = __webpack_public_path__ + "static/img/图层 537.a624edee.png";